import { render } from "./TabPane.vue?vue&type=template&id=cb8e2b72"
import script from "./TabPane.vue?vue&type=script&lang=js"
export * from "./TabPane.vue?vue&type=script&lang=js"

import "./TabPane.vue?vue&type=style&index=0&id=cb8e2b72&lang=scss"

import exportComponent from "../../../vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__